module.exports = __webpack_public_path__ + "media/images/lb/131-44de376978b3d45688f6953036c4e7c6.svg";